/* eslint-disable import/prefer-default-export */
import { PaymentMethod } from '../constants/paymentMethod';

const BOLETO_DEADLINE_DAYS = 5;
const CARD_DEADLINE_DAYS = 7;

function getPaymentDeadlineDays(paymentMethod: string): number {
    if (
        paymentMethod === PaymentMethod.Barcode ||
        paymentMethod === PaymentMethod.CreditCardAndBarcode
    ) {
        return BOLETO_DEADLINE_DAYS;
    }

    return CARD_DEADLINE_DAYS;
}

export function isPaymentDeadlineExpired(
    approvedAt: string | null | undefined,
    paymentMethod: string,
): boolean {
    if (!approvedAt) return false;

    const deadlineDays = getPaymentDeadlineDays(paymentMethod);
    const deadline = new Date(approvedAt);
    deadline.setDate(deadline.getDate() + deadlineDays);

    return new Date() > deadline;
}
